<template>
	<div class="fonts-box pr overflow-hidden">
		<div class="wrap flex content-between items-center flex-wrap">
			<div class="flex items-center">
				<strong class="title db tr fw5">Font:</strong>
				<div class="select-holder">
					<span class="fake-select">
						<select v-on:change="onThemeChange">
							<option v-for="(f) in fonts" :value="f"
									:key="f" :selected="selectedFont === f">{{f}}</option>
						</select>
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapActions, mapState} from "vuex";
	import {types} from "@/store/modules/widget";
	import consts from "@/common/consts";

	export default {
		name: "FontSelector",
		data(){
			return {
				fonts: Object.keys(consts.FONTS),
			}
		},
		computed: {
			...mapState({
				selectedFont: (state)=> state.widget.font,
			})
		},
		methods: {
			...mapActions("widget", [
				types.SELECT_FONT,
			]),
			onThemeChange(e) {
				this[types.SELECT_FONT]({font: e.target.value});
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import "../../../assets/scss/_variables.scss";

	.fonts-box {
		padding: 14px 0 0;
		border-bottom: 1px solid $heather;

		.wrap {
			margin: 0 0 18px;
		}

		.title {
			margin: 0 15px 0 0;
		}
	}
</style>
